import React, { Component } from 'react'
import { Button } from '@material-ui/core'
import './style.scss'
class RoundButton extends Component {
  static propTypes = {}

  render() {
    const { children } = this.props;
    return (
      <Button color="secondary" className="round-button">{children}</Button>
    )
  }
}

export default RoundButton